import React, { useContext } from "react";
import Link from "../../utils/Link";
import Tilt from "react-tilt";
import { LanguageContext, text } from "../../container/language";
import { buildURLForCategory, buildURLForMenuItem } from "../../utils/buildURL";

const Service = (item) => {
  const { userLanguage } = useContext(LanguageContext);

  const { ref, parentCategory, blockMode } = item;
  const { cover, title, slug } = item.article || item.category || item;

  let url = "";

  if (blockMode) {
    url = buildURLForMenuItem(item);
  } else {
    url = `${buildURLForCategory(parentCategory)}/${slug}`;
  }

  return (
    <Tilt
      className="services-list__item"
      options={{
        max: 25,
        scale: 1,
        perspective: 2000,
        easing: "cubic-bezier(.03,.98,.52,.99)",
      }}
    >
      <Link to={url} className="services-list__inner">
        {cover && (
          <div className="services-list__header">
            <img src={cover.url} alt="" />
          </div>
        )}
        <div className="services-list__body">
          <p className="services-list__title">
            <font>
              <font>{text(title, userLanguage)}</font>
            </font>
          </p>
        </div>
      </Link>
    </Tilt>
  );
};

export default Service;
